import { useEffect, useState } from 'react';
import { useAppDispatch } from 'redux-state/configure-store.js';
import { REDUX_MODULE_DATAURL_SET } from 'redux-state/modules-dataurl/reducer.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { ConfigWithDataUrl, REMOVE_MODULE_NAME } from './dataUrlHook.js';

const getConfigTitle = ({ name, title }: Partial<Pick<ConfigWithDataUrl, 'name' | 'title'>>) => {
  if (title || name) {
    return [title, name].filter(isNotNullOrUndefined).join(' ');
  }
  return undefined;
};

/**
 * Manages when to update modules in redux state
 * We have to be careful here as updating this updates secondary section that uses these reudx elements
 */
export function DataUrlComponentUpdate({
  queriedConfig,
  modulePath,
  originalConfig,
}: {
  queriedConfig: ConfigWithDataUrl | undefined;
  modulePath: ModulePath;
  originalConfig: ConfigWithDataUrl | undefined;
}) {
  const appDispatch = useAppDispatch();
  const [loadedDataUrl, setLoadedDataUrl] = useState('');

  useEffect(() => {
    if (queriedConfig) {
      if (queriedConfig?.name === REMOVE_MODULE_NAME) {
        messageLog.info(
          `Module Removed: ${getConfigTitle({ name: originalConfig?.name, title: originalConfig?.title }) || getConfigTitle({ name: queriedConfig?.name, title: queriedConfig?.title })}`,
          ['dataUrl', originalConfig?.dataUrl],
          ['module', originalConfig?.name],
        );
        // appDispatch(REDUX_SECONDARY_MODULE_REMOVE({ path: modulePath, dataUrl: queriedConfig.dataUrl }));
      }
      if (queriedConfig?.dataUrl !== loadedDataUrl) {
        // messageLog.info(
        //   `Module Loaded: ${originalConfig?.title || queriedConfig.title + ' ' + queriedConfig.name}`,
        //   ['dataUrl', originalConfig?.dataUrl],
        //   ['module', originalConfig?.name],
        // );
        setLoadedDataUrl(queriedConfig.dataUrl);
        /**
         * Update the modules config state
         * We need to ensure that this is not being called all the time
         * As it will update the module config causing all modules to update
         */
        appDispatch(REDUX_MODULE_DATAURL_SET({ module: queriedConfig, dataUrl: queriedConfig.dataUrl }));
      }
    }
  }, [
    queriedConfig,
    appDispatch,
    loadedDataUrl,
    modulePath,
    originalConfig?.dataUrl,
    originalConfig?.name,
    originalConfig?.title,
  ]);
}
